<script>
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import { Input } from "@/shared/ui/input";
import { Search } from "lucide-vue-next";
import Button from "@/shared/ui/button/Button.vue";
import { DateRangePicker } from "@/shared/ui/date-picker";

export default {
  name: "LoggingFilter",
  components: {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
    Input,
    Search,
    Button,
    DateRangePicker,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:modelValue", "search", "reset"],
  data() {
    return {
      localStart: this.modelValue.dateRange?.[0] || "",
      localEnd: this.modelValue.dateRange?.[1] || "",
    };
  },
  computed: {
    filters: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    "modelValue.dateRange": {
      handler(range) {
        this.localStart = range?.[0] || "";
        this.localEnd = range?.[1] || "";
      },
    },
  },
  methods: {
    updateStartDate(value) {
      this.localStart = value;
      this.emitDateRange();
    },
    updateEndDate(value) {
      this.localEnd = value;
      this.emitDateRange();
    },
    emitDateRange() {
      if (this._emitScheduled) return;
      this._emitScheduled = true;
      this.$nextTick(() => {
        this._emitScheduled = false;
        this.$emit("update:modelValue", {
          ...this.modelValue,
          dateRange:
            this.localStart && this.localEnd
              ? [this.localStart, this.localEnd]
              : [],
        });
      });
    },
    updateUserQ(value) {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        user_q: value,
      });
      this.$emit("search", "filter");
    },
    resetFilters() {
      this.$emit("reset");
    },
  },
};
</script>

<template>
  <div class="filters">
    <el-scrollbar>
      <div class="flex items-center gap-2 w-max">
        <DateRangePicker
          :start-date="localStart"
          :end-date="localEnd"
          :placeholder="$t('Дата С') + ' — ' + $t('Дата По')"
          trigger-class="h-10 text-sm px-[14px]"
          @update:start-date="updateStartDate"
          @update:end-date="updateEndDate"
        />
        <div class="relative" style="width: 226px">
          <Search
            class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground"
          />
          <Input
            :model-value="filters.user_q"
            @update:model-value="updateUserQ"
            :placeholder="$t('ИИН') + ' / ' + $t('ФИО')"
            size="lg"
            class="pl-9"
          />
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger as-child>
            <div class="chip">
              <div class="text">
                {{ $t("Все модули") }}
              </div>
              <svg-icon name="huge-down" class="icon" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem @click="() => {}">
              {{ $t("Все модули") }}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger as-child>
            <div class="chip">
              <div class="text">
                {{ $t("Все действия") }}
              </div>
              <svg-icon name="huge-down" class="icon" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem @click="() => {}">
              {{ $t("Все модули") }}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </el-scrollbar>
    <Button variant="outline" @click="resetFilters">
      {{ $t("Сбросить фильтр") }}
    </Button>
  </div>
</template>

<style scoped lang="scss">
.filters {
  @apply flex justify-between items-center gap-4;

  .chip {
    @apply h-10 px-[14px] flex items-center gap-2 cursor-pointer select-none border;
    @apply border-border rounded bg-card;

    .icon {
      @apply w-4 h-4 text-muted-foreground shrink-0;
    }
  }

  .text {
    @apply text-foreground text-sm font-medium leading-5;
  }
}
</style>
